import { produce } from 'immer'
import { SENSORS_ACTION_TYPE } from '../constants'

const initState = {
  openAppData: {
    pageName: '',
    id: '',
  }
}

const pageTypeMap = {
  1: {
    pageName: '术友圈详情页'
  },
  2: {
    pageName: '活动日历详情页（直播）'
  },
  3: {
    pageName: '活动精选首页'
  },
  4: {
    pageName: '视频详情页'
  },
  5: {
    pageName: '直播间详情'
  },
  6: {
    pageName: '科室详情页'
  },
  7: {
    pageName: '医生详情'
  },
  8: {
    pageName: '医院详情'
  },
  9: {
    pageName: '出版物详情'
  },
  10: {
    pageName: '专辑详情'
  },
  11: {
    pageName: '活动详情'
  },
  12: {
    pageName: '频道首页'
  },
  13: {
    pageName: '频道子栏目'
  },
  14: {
    pageName: '频道子频道'
  },
  15: {
    pageName: '直播预告列表'
  },
  16: {
    pageName: '直播专题'
  },
  17: {
    pageName: '直播中列表'
  }

}

// eslint-disable-next-line
const sensorsPonintReducer = (state = initState, action) =>
  // eslint-disable-next-line
  produce(state, (draft) => {
    console.log('action.type', action.type, action.payload)
    console.log('draft', draft)
    switch (action.type) {
      case SENSORS_ACTION_TYPE.UPDATE_OPEN_APP_DATA:
        // debugger
        try {
          draft.openAppData = {
            pageName: pageTypeMap[action.payload.type].pageName,
            id: action.payload.id || '',
            ...(action.payload?.queryParams || {}),
            activitiesId: action.payload.activitiesId || '',
            
            // queryParams: action.payload.queryParams || ''
          }
        } catch (e) {
          console.log(e)
        }
        break
      case SENSORS_ACTION_TYPE.CLEAN_OPEN_APP_DATA:
        try {
          draft.openAppData = {
            pageName: '',
            id: ''
          }
        } catch (e) {
          console.log(e)
        }
        break
      default:
        return state
    }
  })

export default sensorsPonintReducer
